import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export const AboutUs: React.FC = () => {
  return (
    <section id="our-story" className="py-24 bg-white scroll-mt-24">
      <div className="max-w-4xl mx-auto px-6 space-y-24">
        
        {/* Container 1: Introduction & Founder Story */}
        <div className="space-y-8">
          <div className="text-center space-y-4">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 tracking-tighter uppercase italic">
              Our Story & Core Philosophy
            </h2>
            <p className="text-xl font-black text-blue-600 uppercase tracking-widest">
            </p>
          </div>
          
          <p className="text-lg text-gray-600 leading-relaxed">
            GrowEzy AI was born from the raw, hard-won experience of a founder who spent years building, growing, and supporting small service businesses independently. Our sole mission is to provide the tools and support small businesses need to thrive, ensuring every transaction is handled with care and transparency.
          </p>

          <p className="text-lg text-gray-600 leading-relaxed">
            Like many operators, our founder originally spent countless hours mapping out tip pooling and distribution in manual spreadsheets. While we successfully grew our operations, we knew there had to be a more efficient way to manage tip distribution. We developed GrowEzy to replace time-consuming, manual work with a reliable, automated system that gives founders more time to focus on what matters: their team and their customers.
          </p>

          <blockquote className="text-xl font-medium text-gray-900 italic border-l-4 border-blue-600 pl-6 py-2">
            "We want every business owner to feel confident about their payroll process, knowing that their tip management is accurate, fair, and effortlessly compliant, allowing them to focus entirely on growth."
          </blockquote>
        </div>

        {/* Container 2: Real Transactions Require Real Documents */}
        <div className="space-y-6 pt-8 border-t border-gray-100">
          <h3 className="text-2xl font-black text-gray-900 uppercase italic tracking-tighter">Tools That Support Your Growth</h3>
          <p className="text-lg text-gray-600 leading-relaxed">
            Running a successful service business relies on clear, organized data. We designed GrowEzy to provide clarity and structured documentation for your daily operations, ensuring you are always ready for growth:
          </p>
          <ul className="space-y-4 text-gray-600">
            <li className="flex gap-4">
              <CheckCircle2 className="text-blue-600 shrink-0" />
              <span><strong>Effortless Compliance:</strong> Generate clear, documented proof of your tip distribution methodology. It provides peace of mind and allows you to focus on running your business, not navigating complex regulatory paperwork.</span>
            </li>
            <li className="flex gap-4">
              <CheckCircle2 className="text-blue-600 shrink-0" />
              <span><strong>Structured Reporting:</strong> Effortlessly create itemized tip logs that bridge the gap between daily operations and payroll requirements, simplifying the reporting process for local, state, and federal labor standards.</span>
            </li>
            <li className="flex gap-4">
              <CheckCircle2 className="text-blue-600 shrink-0" />
              <span><strong>Team Transparency:</strong> Maintain a culture of trust with an exact, fair distribution record that makes it easy to discuss payroll with your staff, ensuring everyone understands how tips are handled.</span>
            </li>
          </ul>
        </div>

        {/* Container 3: Philosophy */}
        <div className="space-y-6 pt-8 border-t border-gray-100">
          <h3 className="text-2xl font-black text-gray-900 uppercase italic tracking-tighter">The GrowEzy Support Philosophy</h3>
          <p className="text-lg text-gray-600 leading-relaxed">
            We developed the GrowEzy method to streamline the delicate balance of tip management. By systematically organizing shift data, labor rules, and payment distribution logic, we help you replace manual guesswork with a process built for accuracy, compliance, and growth.
          </p>
        </div>
      </div>
    </section>
  );
};
